module.exports = __webpack_public_path__ + "static/images/icon-getty.923a2758f1b330a4c9dc77c27f117018.svg";